import { useMirageAnalyticsContext } from "@mirage/analytics/AnalyticsProvider";
import type { PAPEventGeneric } from "@mirage/analytics/events/base/event";
import { atom, useAtomValue } from "jotai";
import { useCallback } from "react";

export const teamInviteLoggingPropertiesAtom = atom<{
  isAdmin: boolean | null;
}>({
  isAdmin: null,
});

export const useDashTeamInvitePapLogger = () => {
  const { reportPapEvent } = useMirageAnalyticsContext();
  const { isAdmin } = useAtomValue(teamInviteLoggingPropertiesAtom);

  const logDashTeamInvitePapEvent = useCallback(
    <
      T extends PAPEventGeneric<
        string,
        string,
        string,
        { isTeamAdmin?: boolean }
      >,
    >(
      event: (properties?: T["properties"]) => T,
      extraProperties?: T["properties"],
    ) => {
      if (typeof isAdmin !== "boolean") {
        return;
      }
      reportPapEvent(
        event({
          isTeamAdmin: isAdmin,
          featureLine: "team_invite",
          ...extraProperties,
        }),
      );
    },
    [isAdmin, reportPapEvent],
  );

  return {
    logDashTeamInvitePapEvent,
  };
};
